import { getBrandingConfigName, loadBrandingConfig } from "./ui/color-config/loadBranding.js";
import { buildEditorDefaultPagePath, resolveEditorTermsUrl } from "./utils/editorAppConfig.js";

const configs = {};
const get = (configs, key, defaultValue) => {
  const el = document.querySelector(`meta[name='env:${key.toLowerCase()}']`);
  if (el) {
    configs[key] = el.getAttribute("content");
  } else {
    configs[key] = defaultValue;
  }
};

get(configs, "REACT_APP_NAME", process.env.REACT_APP_NAME);
get(configs, "THUMBNAIL_SERVER", process.env.THUMBNAIL_SERVER);
get(configs, "CORS_PROXY_SERVER", process.env.CORS_PROXY_SERVER);
get(configs, "NON_CORS_PROXY_DOMAINS", process.env.NON_CORS_PROXY_DOMAINS);
get(configs, "SENTRY_DSN", process.env.SENTRY_DSN);
get(configs, "BASE_ASSETS_PATH", process.env.BASE_ASSETS_PATH);
get(configs, "ROUTER_BASE_PATH", process.env.ROUTER_BASE_PATH);
get(configs, "IS_MOZ", process.env.IS_MOZ);
get(configs, "CUSTOM_API_URL", process.env.CUSTOM_API_URL);
get(configs, "SUBSCRIPTION_API_URL", process.env.SUBSCRIPTION_API_URL);
get(configs, "JWT_COOKIE", process.env.JWT_COOKIE);
get(configs, "IS_DEV", process.env.NODE_ENV !== "production");
get(configs, "APP_NAME", process.env.APP_NAME);
get(configs, "CUSTOM_HOST", process.env.CUSTOM_HOST);
get(configs, "XRHUB_URL", process.env.XRHUB_URL);
get(configs, "AUTH0_DOMAIN", process.env.AUTH0_DOMAIN);
get(configs, "AUTH0_CLIENT_ID", process.env.AUTH0_CLIENT_ID);
get(configs, "AUTH0_AUDIENCE", process.env.AUTH0_AUDIENCE);
get(configs, "AUTH0_COOKIE_DOMAIN", process.env.AUTH0_COOKIE_DOMAIN);
get(configs, "AUTH0_REDIRECT", process.env.AUTH0_REDIRECT);
get(configs, "AUTH0_POPUP_TIMEOUT_SECONDS", process.env.AUTH0_POPUP_TIMEOUT_SECONDS || "300");
get(configs, "AUTH_COOKIE_PREFIX", process.env.AUTH_COOKIE_PREFIX);
get(configs, "AUTH_BRIDGE_URL", process.env.AUTH_BRIDGE_URL);
get(configs, "AUTH_BRIDGE_CLIENT_ID", process.env.AUTH_BRIDGE_CLIENT_ID || "editor");
get(configs, "SKETCHFAB_API_KEY", process.env.SKETCHFAB_API_KEY);
get(configs, "AR_HOST", process.env.AR_HOST);
get(configs, "AR_API_HOST", process.env.AR_API_HOST);
get(configs, "GA_MEASUREMENT_ID", process.env.GA_MEASUREMENT_ID);
get(configs, "GA4_GLOBAL_MEASUREMENT_ID", process.env.GA4_GLOBAL_MEASUREMENT_ID);
get(configs, "DOCS_URL", process.env.DOCS_URL);
get(configs, "ENVIRONMENT", process.env.ENVIRONMENT);
get(configs, "CUSTOM_API_URL_V2", process.env.CUSTOM_API_URL_V2);
get(configs, "PRICING_PAGE_URL", process.env.PRICING_PAGE_URL);
get(configs, "OPENAI_API", process.env.OPENAI_API);
get(configs, "ENVIRONMENT", process.env.ENVIRONMENT);
get(configs, "PERSISTENCE_API_URL", process.env.PERSISTENCE_API_URL);
get(configs, "PERSISTENCE_API_KEY", process.env.PERSISTENCE_API_KEY);
get(configs, "PUBLIC_ART_API", process.env.PUBLIC_ART_API);
get(configs, "AR_EDITOR", process.env.AR_EDITOR);
get(configs, "DEFAULT_PAGE_PATH", process.env.DEFAULT_PAGE_PATH || "/");
get(configs, "MODEL_VIEWER_URL", process.env.MODEL_VIEWER_URL || "https://model-viewer.onland.io/model-viewer.min.js");
get(
  configs,
  "OPENAI_COMPLETION_MODELS",
  process.env.OPENAI_COMPLETION_MODELS ||
    "gpt-5-mini,gpt-5-nano,gpt-4o-mini,gpt-5.1,gpt-5.2,gpt-4o,gpt-4.1,gpt-4.1-mini,gpt-4.1-nano"
);

const folder = getBrandingConfigName(configs.REACT_APP_NAME);

const branding = loadBrandingConfig(configs.REACT_APP_NAME);

const logos = window?.APP_CONFIG?.images?.favicon ? window.APP_CONFIG.images.favicon : branding.head.favicon;

const logosBig = () => {
  return logos;
};

const tutorialImage = () => {
  try {
    return require(`./assets/onboarding/${folder}/default.jpg`);
  } catch (e) {
    return require(`./assets/onboarding/default.jpg`);
  }
};

if (configs.BASE_ASSETS_PATH) {
  // eslint-disable-next-line no-undef
  __webpack_public_path__ = configs.BASE_ASSETS_PATH;
}

function fixBaseAssetsPath(path) {
  // eslint-disable-next-line no-undef
  if (!path.startsWith(__webpack_public_path__)) {
    // eslint-disable-next-line no-useless-escape
    const matches = path.match(/^([^\/]+\/).+$/);

    if (matches.length > 1) {
      // eslint-disable-next-line no-undef
      return __webpack_public_path__ + path.replace(matches[1], "");
    }
  }

  return path;
}

configs.isMoz = () => false;
configs.name = () => "XR Creator";
configs.longName = () => (configs.APP_NAME ? configs.APP_NAME + " XR Creator" : "XR Creator");
configs.tutorialImage = () => fixBaseAssetsPath(tutorialImage());
configs.icon = () => logos;
configs.logos = () => logosBig();
configs.docsUrl = () => configs.DOCS_URL;
configs.docsOptimizationUrl = () => configs.DOCS_URL + branding?.docsFolder?.optimization;
configs.editorDocs = () => configs.DOCS_URL + (branding?.docsFolder?.home || "/category/xr-creator-studio");
configs.editorCreatorControls = () =>
  configs.DOCS_URL + (branding?.docsFolder?.controls || "/xr-creator/Creator-controls");

configs.basePath = () => window.location.origin + configs.ROUTER_BASE_PATH;
configs.defaultPagePath = () =>
  buildEditorDefaultPagePath(configs.DEFAULT_PAGE_PATH, {
    routerBasePath: configs.ROUTER_BASE_PATH
  });

function normalizeOptionalUrl(value) {
  const normalized = String(value || "")
    .trim()
    .replace(/\/+$/, "");

  return /^https?:\/\//i.test(normalized) ? normalized : "";
}

function deriveAuthBridgeUrlFromApiUrl(customApiUrl) {
  const apiUrl = normalizeOptionalUrl(customApiUrl);
  if (!apiUrl) {
    return "";
  }

  try {
    const url = new URL(apiUrl);
    url.pathname = url.pathname.replace(/\/(?:nri\/)?api\/?$/i, "") || "/";
    url.search = "";
    url.hash = "";
    return url.toString().replace(/\/+$/, "");
  } catch (_error) {
    return "";
  }
}

configs.authBridgeUrl = () =>
  normalizeOptionalUrl(configs.AUTH_BRIDGE_URL) || deriveAuthBridgeUrlFromApiUrl(configs.CUSTOM_API_URL);
configs.authBridgeClientId = () => configs.AUTH_BRIDGE_CLIENT_ID || "editor";

configs.isLocal = configs.ENVIRONMENT === "local";

configs.ADMIN_PERMISSION = "manage-users";
configs.CREATOR_PERMISSION = "project:create";
configs.MANAGE_ROLES_PERMISSION = "manage-roles";
configs.ANALYTICS_PERMISSION = "analytics";
configs.CREATE_VERSES_INSTANCES_PERMISSION = "verse:create";
configs.CREATE_INSTANT_ACCESSES_PERMISSION = "instant-access:create";

configs.tutorialUrl = () => "https://www.youtube.com/@themudfoundation/featured";

configs.footerName =
  folder === "mud"
    ? `Copyright ${new Date().getFullYear()} © All rights reserved. MUD Foundation INC`
    : "Powered By MUD XR Platform";
// Use branding termsUrl if available, otherwise hand off to XRHub.
configs.termsUrl = resolveEditorTermsUrl({
  brandingTermsUrl: branding?.footer?.termsUrl,
  xrhubUrl: configs.XRHUB_URL,
  locationOrigin: window.location.origin
});

configs.pdfjsLib = "https://cdn.jsdelivr.net/npm/pdfjs-dist@5.4.296/build/pdf.min.mjs";
configs.pdfjsWorker = "https://cdn.jsdelivr.net/npm/pdfjs-dist@5.4.296/build/pdf.worker.min.mjs";
configs.openAICompletionModels = () =>
  Array.from(
    new Set(
      String(configs.OPENAI_COMPLETION_MODELS || "")
        .split(",")
        .map(model => model.trim())
        .filter(Boolean)
    )
  );

// Workspace roles
configs.WORKSPACE_ROLES = {
  PRIMARY_OWNER: "primaryOwner",
  OWNER: "owner",
  CONTRIBUTOR: "contributor",
  VIEWER: "viewer"
};

configs.AUTO_SAVE_INTERVAL_SECONDS = 600;

export default configs;
